export const colormaps = {
  cropland: {
    Background: 'rgb(0, 0, 0)',
    Corn: 'rgb(255, 212, 0)',
    Cotton: 'rgb(255, 38, 38)',
    Rice: 'rgb(0, 169, 230)',
    Sorghum: 'rgb(255, 158, 15)',
    Soybeans: 'rgb(38, 115, 0)',
    Sunflower: 'rgb(255, 255, 0)',
    Peanuts: 'rgb(112, 168, 0)',
    Tobacco: 'rgb(0, 175, 77)',
    'Sweet Corn': 'rgb(224, 166, 15)',
    'Pop or Orn Corn': 'rgb(224, 166, 15)',
    Mint: 'rgb(128, 212, 255)',
    Barley: 'rgb(226, 0, 127)',
    'Durum Wheat': 'rgb(138, 100, 83)',
    'Spring Wheat': 'rgb(217, 181, 108)',
    'Winter Wheat': 'rgb(168, 112, 0)',
    'Other Small Grains': 'rgb(214, 157, 188)',
    'Dbl Crop WinWht/Soybeans': 'rgb(115, 115, 0)',
    Rye: 'rgb(174, 1, 126)',
    Oats: 'rgb(161, 88, 137)',
    Millet: 'rgb(115, 0, 76)',
    Speltz: 'rgb(214, 157, 188)',
    Canola: 'rgb(209, 255, 0)',
    Flaxseed: 'rgb(128, 153, 255)',
    Safflower: 'rgb(214, 214, 0)',
    'Rape Seed': 'rgb(209, 255, 0)',
    Mustard: 'rgb(0, 175, 77)',
    Alfalfa: 'rgb(255, 168, 227)',
    'Other Hay/Non Alfalfa': 'rgb(165, 245, 141)',
    Camelina: 'rgb(0, 175, 77)',
    Buckwheat: 'rgb(214, 157, 188)',
    Sugarbeets: 'rgb(169, 0, 230)',
    'Dry Beans': 'rgb(168, 0, 0)',
    Potatoes: 'rgb(115, 38, 0)',
    'Other Crops': 'rgb(0, 175, 77)',
    Sugarcane: 'rgb(179, 128, 255)',
    'Sweet Potatoes': 'rgb(115, 38, 0)',
    'Misc Vegs & Fruits': 'rgb(255, 102, 102)',
    Watermelons: 'rgb(255, 102, 102)',
    Onions: 'rgb(255, 204, 102)',
    Cucumbers: 'rgb(255, 102, 102)',
    'Chick Peas': 'rgb(0, 175, 77)',
    Lentils: 'rgb(0, 222, 176)',
    Peas: 'rgb(85, 255, 0)',
    Tomatoes: 'rgb(245, 162, 122)',
    Caneberries: 'rgb(255, 102, 102)',
    Hops: 'rgb(0, 175, 77)',
    Herbs: 'rgb(128, 212, 255)',
    'Clover/Wildflowers': 'rgb(232, 190, 255)',
    'Sod/Grass Seed': 'rgb(178, 255, 222)',
    Switchgrass: 'rgb(0, 175, 77)',
    'Fallow/Idle Cropland': 'rgb(191, 191, 122)',
    Forest: 'rgb(149, 206, 147)',
    Shrubland: 'rgb(199, 215, 158)',
    Barren: 'rgb(204, 191, 163)',
    Cherries: 'rgb(255, 0, 255)',
    Peaches: 'rgb(255, 145, 171)',
    Apples: 'rgb(185, 0, 80)',
    Grapes: 'rgb(112, 68, 137)',
    'Christmas Trees': 'rgb(0, 120, 120)',
    'Other Tree Crops': 'rgb(179, 156, 112)',
    Citrus: 'rgb(255, 255, 128)',
    Pecans: 'rgb(182, 112, 92)',
    Almonds: 'rgb(0, 168, 132)',
    Walnuts: 'rgb(235, 214, 176)',
    Pears: 'rgb(179, 156, 112)',
    'Clouds/No Data': 'rgb(247, 247, 247)',
    Developed: 'rgb(156, 156, 156)',
    Water: 'rgb(77, 112, 163)',
    Wetlands: 'rgb(128, 179, 179)',
    'Nonag/Undefined': 'rgb(233, 255, 190)',
    Aquaculture: 'rgb(0, 255, 255)',
    'Open Water': 'rgb(77, 112, 163)',
    'Perennial Ice/Snow ': 'rgb(212, 227, 252)',
    'Developed/Open Space': 'rgb(156, 156, 156)',
    'Developed/Low Intensity': 'rgb(156, 156, 156)',
    'Developed/Med Intensity': 'rgb(156, 156, 156)',
    'Developed/High Intensity': 'rgb(156, 156, 156)',
    'Deciduous Forest': 'rgb(149, 206, 147)',
    'Evergreen Forest': 'rgb(149, 206, 147)',
    'Mixed Forest': 'rgb(149, 206, 147)',
    'Grass/Pasture': 'rgb(233, 255, 190)',
    'Woody Wetlands': 'rgb(128, 179, 179)',
    'Herbaceous Wetlands': 'rgb(128, 179, 179)',
    Pistachios: 'rgb(0, 255, 140)',
    Triticale: 'rgb(214, 157, 188)',
    Carrots: 'rgb(255, 102, 102)',
    Asparagus: 'rgb(255, 102, 102)',
    Garlic: 'rgb(255, 102, 102)',
    Cantaloupes: 'rgb(255, 102, 102)',
    Prunes: 'rgb(255, 145, 171)',
    Olives: 'rgb(52, 74, 52)',
    Oranges: 'rgb(230, 117, 37)',
    'Honeydew Melons': 'rgb(255, 102, 102)',
    Broccoli: 'rgb(255, 102, 102)',
    Avocados: 'rgb(102, 153, 77)',
    Peppers: 'rgb(255, 102, 102)',
    Pomegranates: 'rgb(179, 156, 112)',
    Nectarines: 'rgb(255, 145, 171)',
    Greens: 'rgb(255, 102, 102)',
    Plums: 'rgb(255, 145, 171)',
    Strawberries: 'rgb(255, 102, 102)',
    Squash: 'rgb(255, 102, 102)',
    Apricots: 'rgb(255, 145, 171)',
    Vetch: 'rgb(0, 175, 77)',
    'Dbl Crop WinWht/Corn': 'rgb(255, 212, 0)',
    'Dbl Crop Oats/Corn': 'rgb(255, 212, 0)',
    Lettuce: 'rgb(255, 102, 102)',
    'Dbl Crop Triticale/Corn': 'rgb(255, 212, 0)',
    Pumpkins: 'rgb(255, 102, 102)',
    'Dbl Crop Lettuce/Durum Wht': 'rgb(138, 100, 83)',
    'Dbl Crop Lettuce/Cantaloupe': 'rgb(255, 102, 102)',
    'Dbl Crop Lettuce/Cotton': 'rgb(255, 38, 38)',
    'Dbl Crop Lettuce/Barley': 'rgb(226, 0, 127)',
    'Dbl Crop Durum Wht/Sorghum': 'rgb(255, 158, 15)',
    'Dbl Crop Barley/Sorghum': 'rgb(255, 158, 15)',
    'Dbl Crop WinWht/Sorghum': 'rgb(168, 112, 0)',
    'Dbl Crop Barley/Corn': 'rgb(255, 212, 0)',
    'Dbl Crop WinWht/Cotton': 'rgb(168, 112, 0)',
    'Dbl Crop Soybeans/Cotton': 'rgb(38, 115, 0)',
    'Dbl Crop Soybeans/Oats': 'rgb(38, 115, 0)',
    'Dbl Crop Corn/Soybeans': 'rgb(255, 212, 0)',
    Blueberries: 'rgb(0, 0, 153)',
    Cabbage: 'rgb(255, 102, 102)',
    Cauliflower: 'rgb(255, 102, 102)',
    Celery: 'rgb(255, 102, 102)',
    Radishes: 'rgb(255, 102, 102)',
    Turnips: 'rgb(255, 102, 102)',
    Eggplants: 'rgb(255, 102, 102)',
    Gourds: 'rgb(255, 102, 102)',
    Cranberries: 'rgb(255, 102, 102)',
    'Dbl Crop Barley/Soybeans': 'rgb(38, 115, 0)',
  },
  nlcd: {
    'No Data': 'rgb(0, 0, 0)',
    'Open Water': 'rgb(70, 107, 159)',
    'Perennial Ice/Snow': 'rgb(209, 222, 248)',
    'Developed, Open Space': 'rgb(222, 197, 197)',
    'Developed, Low Intensity': 'rgb(217, 146, 130)',
    'Developed, Medium Intensity': 'rgb(235, 0, 0)',
    'Developed, High Intensity': 'rgb(171, 0, 0)',
    'Barren Land (Rock/Sand/Clay)': 'rgb(179, 172, 159)',
    'Deciduous Forest': 'rgb(104, 171, 95)',
    'Evergreen Forest': 'rgb(28, 95, 44)',
    'Mixed Forest': 'rgb(181, 197, 143)',
    'Shrub/Scrub': 'rgb(204, 184, 121)',
    'Grassland/Herbaceous': 'rgb(223, 223, 194)',
    'Pasture/Hay': 'rgb(220, 217, 57)',
    'Cultivated Crops ': 'rgb(171, 108, 40)',
    'Woody Wetlands': 'rgb(184, 217, 235)',
    'Emergent Herbaceous Wetlands': 'rgb(108, 159, 184)',
    Other: '#ffffff',
  },
  aquifers: {
    'Unconsolidated and semiconsolidated sand and gravel aquifers': '#ace0e7',
    'Unconsolidated sand and gravel aquifers': '#ace0e7',
    'Semiconsolidated sand aquifers': '#fff76c',
    'Sandstone aquifers': '#9ec2a5',
    'Sandstone and carbonate-rock aquifers': '#b299b9',
    'Carbonate-rock aquifers': '#c2ac98',
    'Igneous and metamorphic-rock aquifers': '#f48080',
    Other: '#ffffff',
  },
};
